import { observable, action, runInAction } from 'mobx'
import Api from '@api/xiu_yan/marketingToolsApi'
import indexStore from '../Tabs/store'
import mainStore from '@components/Main/store'
import { message, Modal } from 'hljd'

const confirm = Modal.confirm

class Store {
  @observable least

  @action
  doLeast = () => {
    const {
      merchantInfo: { property_id }
    } = mainStore
    switch (+property_id) {
      case 11:
        this.least = 1
        break
      case 2:
      case 8:
      case 9:
        this.least = 2
        break
      case 7:
        this.least = 3
        break
      case 6:
      case 12:
        this.least = 4
        break
    }
  }

  @observable list = []
  @observable ids = []
  @observable status
  @observable reason

  @action
  getStatus = async () => {
    let { data } = await Api.record_list()
    runInAction(() => {
      this.status = data[1].status
    })
  }

  @action
  getPromise = async () => {
    let {
      data: { option_list, reason }
    } = await Api.current_list({ id: 5 })
    runInAction(() => {
      this.list = option_list
      this.reason = reason

      this.ids = option_list.map(({ id, status }) => {
        return { id, status }
      })
    })
  }

  @action
  changeCheck = (id, index) => e => {
    Object.assign(this.ids[index], {
      status: e.target.checked ? 1 : 0
    })
  }

  @action
  savePromise = async () => {
    const { ids, least, status } = this

    let _ids = []
    ids.forEach(({ id, status }) => {
      if (status == 1) {
        _ids.push(id)
      }
    })

    if (_ids.length < least) {
      return message.warning('请至少选择' + least + '个！')
    }

    let params = {
      grade_privilege_id: 5,
      ids: _ids,
      status: 1
    }

    let apiName
    if (status == 0) {
      apiName = Api.add(params)
    } else {
      apiName = Api.edit(params)
    }

    let { success } = await apiName

    if (success) {
      message.success('操作成功！')
      window.location.href = '#/localMerchant/marketingTools?key=5'
    }
  }

  @action
  closePromise = () => {
    let params = {
      grade_privilege_id: 5,
      status: 0
    }

    confirm({
      title: '确定要关闭商家承诺',
      onOk: async () => {
        let { success } = await Api.edit(params)
        if (success) {
          message.success('操作成功！')
          indexStore.getTabInfo()
          indexStore.getCurrentList(5)
        }
      }
    })
  }
}
export default new Store()
